import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./tonconnect-overrides.css";
import App from "./App.jsx";
import TonConnectProvider from "./components/TonConnectProvider.jsx";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <TonConnectProvider>
      <App />
    </TonConnectProvider>
  </StrictMode>
);
